import { i18ns } from '@naruto/naruto-models/src/core/i18n';
import AvailableList from './list';

const APP_DOMAIN = 'bgdapp';

export const initializeLangConfig = (): void => {
  i18ns.setLocaleData(APP_DOMAIN, AvailableList);
  i18ns.setCurrentDomain(APP_DOMAIN);

  /* change Language automatic if user had set before */
  const currentLanguage = i18ns.currentLanguage;
  if (currentLanguage) i18ns.setCurrentLanguage(currentLanguage);
};
